import { CloseCircleOutlined, FormOutlined } from '@ant-design/icons';
import { useState } from 'react';
import styles from 'styles/components/instructions.module.scss';
const { Input, Button } = require('antd');

const CHOICE = {
  YES: 'yes',
  NO: 'no',
};

const Instructions = ({
  onChangeInstructions,
  onChangeHasRespondedToInstructions = () => {},
}) => {
  const [choice, setChoice] = useState(null);

  return (
    <div className={styles.instructionsWrapper}>
      <div className={styles.instructionsTitle}>
        <b>Instructions (optional)</b>
        <br />
        <span style={{ color: '#bdbdbd' }}>
          Specify the desired URL and anchor text.
        </span>
      </div>
      <div className={styles.cta}>
        <Button
          type="primary"
          ghost={!choice || choice === CHOICE.NO}
          onClick={() => {
            setChoice(CHOICE.YES);
            onChangeHasRespondedToInstructions();
          }}
          icon={<FormOutlined />}
        >
          Yes, leave instructions
        </Button>
        <Button
          type="primary"
          ghost={!choice || choice === CHOICE.YES}
          onClick={() => {
            setChoice(CHOICE.NO);
            onChangeHasRespondedToInstructions();
          }}
          icon={<CloseCircleOutlined />}
        >
          No instructions
        </Button>
      </div>

      {choice === CHOICE.YES && (
        <div style={{ marginTop: 12 }}>
          <Input.TextArea
            onChange={onChangeInstructions}
            placeholder="Enter instructions for your backlink"
            defaultValue={"Preferred anchor URL:\nPreferred anchor text:"}
          />
        </div>
      )}
    </div>
  );
};

export default Instructions;
